import { createRouter, createWebHistory } from 'vue-router';

//
//  Lazy load the Home view so it only loads when required.
//
function loadHomeView() {
    return import('../views/order/HomeView.vue');
}

const routes = [
  { path: "/", name: "Home", component: loadHomeView },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/site/About/AboutView.vue"),
  },
  {
    path: "/accepted",
    name: "Accepted",
    component: () => import("../views/order/AcceptedView.vue"),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/legal/PrivacyPolicyView.vue"),
  },
  {
    path: "/terms-of-service",
    name: "TermsOfService",
    component: () => import("../views/legal/TermsOfServiceView.vue"),
  },
  {
    path: "/support",
    name: "Support",
    component: function () {
      return import("../views/support/SupportView.vue");
    },
  },
  {
    path: "/support/received",
    name: "SupportReceived",
    component: function () {
      return import("../views/support/ReceivedView.vue");
    },
  },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
